import type { ContainerModuleLoader } from '@wix/thunderbolt-ioc'
import { ComponentWillMountSymbol } from 'feature-components'
import { BuilderComponentLoaderSymbol, BuilderComponentRegistrarSymbol, BuilderComponentResolverSymbol } from './symbols'
import { PlatformEnvDataProviderSymbol } from '@wix/thunderbolt-symbols'
import { builderComponentWillMount } from './builderComponentWillMount'
import { builderComponentRegistrar } from './builderComponentRegistrar'
import { builderComponentLoader } from './builderComponentLoader'
import { builderComponentResolver } from './builderComponentResolver'

export const page: ContainerModuleLoader = (bind) => {
	bind(ComponentWillMountSymbol).to(builderComponentWillMount)
}

export const site: ContainerModuleLoader = (bind) => {
	bind(BuilderComponentLoaderSymbol).to(builderComponentLoader)
	bind(BuilderComponentRegistrarSymbol).to(builderComponentRegistrar)
	bind(BuilderComponentResolverSymbol, PlatformEnvDataProviderSymbol).to(builderComponentResolver)
}

export * from './types'
export * from './symbols'
